import { agentsApi } from '../../../data/agentsApi';
import type { AgentRunPageView, AgentRunDetailView } from './runsViews';

/**
 * Runs feature endpoints, injected into the single agents base api.
 *
 * Post-045 case-centric slim-down: the batch-era run *list* and its health widget are gone — the
 * feature now owns only the per-case reads the worklist case dialog needs: the run detail and the
 * subject-scoped run history (`GET /agents/{key}/runs?subjectId=`, the spec-042 filter).
 */
export const runsEndpoints = agentsApi.injectEndpoints({
  endpoints: (builder) => ({
    getRunDetail: builder.query<AgentRunDetailView, { agentKey: string; runId: string; company?: string }>({
      query: ({ agentKey, runId, company }) => ({
        url: `/agents/${agentKey}/runs/${runId}`,
        method: 'GET',
        params: company ? { company } : undefined,
      }),
      providesTags: (_result, _error, { agentKey }) => [{ type: 'AgentRuns', id: agentKey }],
    }),
    getRunsForSubject: builder.query<
      AgentRunPageView,
      { agentKey: string; subjectId: string; company?: string; pageSize?: number }
    >({
      query: ({ agentKey, subjectId, company, pageSize }) => ({
        url: `/agents/${agentKey}/runs`,
        method: 'GET',
        params: {
          subjectId,
          ...(company ? { company } : {}),
          ...(pageSize ? { pageSize } : {}),
        },
      }),
      providesTags: (_result, _error, { agentKey, subjectId }) => [
        { type: 'AgentRuns', id: `${agentKey}:${subjectId}` },
        { type: 'AgentRuns', id: agentKey },
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetRunDetailQuery,
  useGetRunsForSubjectQuery,
} = runsEndpoints;
